export const employerPOCMappingTo9089SectionB = {
  name: "Employer POC Form Mapping",
  machine_name: "employer_9089_profile_mapping",
  targetFormDetailName: "Form ETA-9089",
  targetSectionName: "Employer Point-of-Contact</br> Information",
  targetSectionLabel: "B",
  fields: [
    {
      profileFieldName: "poc_emp_last_name",
      formTargetField: "empPocLastName",
    },
    {
      profileFieldName: "poc_emp_first_name",
      formTargetField: "empPocFirstName",
    },
    {
      profileFieldName: "poc_emp_middle_name",
      formTargetField: "empPocMiddleName",
    },
    {
      profileFieldName: "poc_emp_job_title",
      formTargetField: "empPocJobTitle",
    },
    {
      profileFieldName: "poc_emp_address1",
      formTargetField: "empPocAddr1",
    },
    {
      profileFieldName: "poc_emp_address2",
      formTargetField: "empPocAddr2",
    },
    {
      profileFieldName: "poc_emp_city",
      formTargetField: "empPocCity",
    },
    {
      profileFieldName: "poc_emp_country_id",
      formTargetField: "empPocCountry",
    },
    {
      profileFieldName: "poc_emp_state_id",
      formTargetField: "empPocState",
    },
    {
      profileFieldName: "poc_emp_zip",
      formTargetField: "empPocPostalCode",
    },
    {
      profileFieldName: "poc_emp_province",
      formTargetField: "empPocProvince",
    },
    {
      profileFieldName: "poc_emp_phone",
      formTargetField: "empPocPhone",
    },
    {
      profileFieldName: "poc_emp_phone_ext",
      formTargetField: "empPocPhoneExt",
    },
    {
      profileFieldName: "poc_emp_email",
      formTargetField: "empPocEmail",
    },
  ],
};

export const employerMappingTo9089SectionA = {
  name: "Employer Profile Form Mapping",
  machine_name: "employer_9089_profile_mapping",
  targetFormDetailName: "Form ETA-9089",
  targetSectionName: "Employer Information",
  targetSectionLabel: "A",
  fields: [
    {
      profileFieldName: "new_profile_emp_legal_name",
      formTargetField: "empBusinessName",
    },
    {
      profileFieldName: "new_profile_emp_dba",
      formTargetField: "empTradeName",
    },
    {
      profileFieldName: "new_profile_emp_address1",
      formTargetField: "empAddr1",
    },
    {
      profileFieldName: "new_profile_emp_address2",
      formTargetField: "empAddr2",
    },
    {
      profileFieldName: "new_profile_emp_city",
      formTargetField: "empCity",
    },
    {
      profileFieldName: "new_profile_emp_country_id",
      formTargetField: "empCountry",
    },
    {
      profileFieldName: "new_profile_emp_state_id",
      formTargetField: "empState",
    },
    {
      profileFieldName: "new_profile_emp_zip",
      formTargetField: "empPostcode",
    },
    {
      profileFieldName: "new_profile_emp_province",
      formTargetField: "empProvince",
    },
    {
      profileFieldName: "new_profile_emp_phone",
      formTargetField: "empPhone",
    },
    {
      profileFieldName: "new_profile_emp_phone_ext",
      formTargetField: "empPhoneext",
    },
    {
      profileFieldName: "new_profile_emp_fein",
      formTargetField: "empFein",
    },
    {
      profileFieldName: "new_profile_emp_naics_description",
      formTargetField: "empNaicsDesc",
    },
    {
      profileFieldName: "new_profile_emp_naics",
      formTargetField: "empNaics",
    },
    {
      profileFieldName: "new_profile_emp_year_commenced",
      formTargetField: "empYearCommenced",
    },
  ],
};
